export const WELCOME = "welcome";
export const HOME = "home";
export const NEW_OBJECT = "newObject";
export const EDIT_OBJECT = "editObject";
export const MOVE = "move";
export const REFRESH_MULTI = "refreshMulti";
export const NEW_DOCUMENT = "newDocument";
export const DETAILS_DOCUMENT = "detailsDocument";
export const DOCUMENTS_LISTS = "documentsList";
export const TEMPLATE = "template";
export const DOCUMENT_PROPERTIES = "documentProperties";
export const SETTINGS = "settings";
export const CHOOSECONFIG = "login";
export const SYNCH_RESTORE = "synchRestore";
export const IMPORT = "importDocument";
export const VALIDATION = "Validation";
export const OBJECTS_LIST = "objectsList";
export const UPDATES = "updates";
export const SOURCES = "sources";
export const INFO = "info";
export const IXBRL = "IXBRL";
export const COPY_CUT_PASTE_PANEL_MESSAGE = "COPY_CUT_PASTE_PANEL_MESSAGE";
export const DOWNLOAD_COPY = "DOWNLOAD_COPY";
export const MAINTENANCEMODE = "MAINTENANCEMODE";
export const TROUBLESHOOTING_TOOLS = "troubleshootingTools";

/**
 * Pages that render their own bounded, scrollable region and therefore must own their scroll at the
 * shell level: for these, App switches the outer contentWrap to `overflow: hidden` so only the page's
 * inner scroll container scrolls. Without this, the shell and the inner container each show a
 * scrollbar, producing a nested/double scrollbar (IDS-7240). Export is reached through the
 * documents-list / document-properties pages; Import is its own page.
 */
export const SELF_SCROLL_PAGES: readonly string[] = [DOCUMENTS_LISTS, DOCUMENT_PROPERTIES, IMPORT];

export const isSelfScrollPage = (page: string | undefined | null): boolean =>
  page != null && SELF_SCROLL_PAGES.includes(page);
